module.exports = __webpack_public_path__ + "static/media/bronze.5963cdd8.png";